import {BalanceTillBreakdownReportModel} from "./balance-till-breakdown-report.model";
import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";
@Component({
    selector: "wbo-balance-till-breakdown-report",
    templateUrl: "./balance-till-breakdown-report.component.html",
    providers: [provideReportModel(BalanceTillBreakdownReportModel)]
})
export class BalanceTillBreakdownReportComponent extends AbstractReportPage {
    constructor(public model: BalanceTillBreakdownReportModel) {
        super();
    }
}
